import React, { Suspense } from "react";
import "./Aboutus.css";
import SampleGallary from "./Gallary/SampleGallary";
import LoadingSpinner from "../Loader/Loader";
import SampleGallary1 from "./Gallery1/SampleGallery1";
import SEO from "../../SEO";
import BookingComponent from "../Our Treatments 2/BookNow/BookNowCall";
// Lazy load the YouTube video component
const YoutubeVideoCarousel1 = React.lazy(() =>
  import("./Youtub_Video_links/Youtub_video")
);

const AboutUs = () => {
  return (
    <div className="About_us_page_container">
      <SEO
        title="About Us"
        description="About Us"
        keywords="spa, massage, therapy, wellness ,about us"
        canonical='https://shrikrishnaarogyammassagestherapy.com/about-us'
      />
      <section className="About_us_page_header">
        <h1 className="About_us_page_title">About Us</h1>
        <h5>
          The Shrikrishna Arogyam Massage & Therapy Center is a place where
          wisdom and well-being collide. Having served the community for more
          than five years, we take great pride in offering massage and therapy
          services that are customized to meet your specific needs. To
          encourage relaxation, reduce discomfort, and improve general
          well-being, our team of knowledgeable therapists blends age-old
          methods with innovative approaches. At Shrikrishna Arogyam, we put
          your comfort and happiness first, making sure that each session is a
          healing experience. Our facility provides a peaceful haven where you
          can unwind and regain mental and physical harmony, whether your
          goals are stress reduction, releasing tense muscles, or just
          treating yourself. At Shrikrishna Arogyam Massage and Therapy
          Center, discover the difference this is where your path to perfect
          health begins.
        </h5>
      </section>

      {/* Lazy-loaded YouTube video carousel */}
      <section className="About_us_Video">
        <Suspense fallback={<LoadingSpinner />}>
          <YoutubeVideoCarousel1 />
        </Suspense>
      </section>
      <SampleGallary />
      <SampleGallary1 />
      <BookingComponent/>
    </div>
  );
};

export default AboutUs;
